module.exports = __webpack_public_path__ + "media/images/default/lp_about_under_line-48f01b6e764f1408342a9dd35a23de4b.svg";